import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import { icon } from './ui';
import { portalEvent, portalHome } from './portalApi';
export class GlobalPortalShell extends Component {
  data = {
    announcements: []
  };
  dismissed = [];
  consent = (() => localStorage.getItem('nt-analytics-consent'))();
  started = (() => Date.now())();
  checkpoint = (() => Date.now())();
  timer = null;
  oninit(vnode) {
    super.oninit(vnode);
    try {
      this.dismissed = JSON.parse(localStorage.getItem('nt-dismissed-announcements') || '[]');
    } catch {
      this.dismissed = [];
    }
    portalHome().then(data => {
      this.data = data;
      const settings = data.settings || {};
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = settings['seo.site_description'] || 'NovaTruck & RP — społeczność i polski serwer MTA';
      let robots = document.querySelector('meta[name="robots"]');
      if (!robots) {
        robots = document.createElement('meta');
        robots.name = 'robots';
        document.head.appendChild(robots);
      }
      robots.content = settings['seo.robots'] || 'index,follow';
      m.redraw();
    });
    if (this.consent === 'yes') this.track('page_view');
    window.addEventListener('beforeunload', this.finish);
    document.addEventListener('visibilitychange', this.visibility);
    this.timer = window.setInterval(this.finish, 60000);
  }
  onremove() {
    window.removeEventListener('beforeunload', this.finish);
    document.removeEventListener('visibilitychange', this.visibility);
    if (this.timer) clearInterval(this.timer);
  }
  visibility = () => {
    if (document.visibilityState === 'hidden') this.finish();
  };
  finish = () => {
    const now = Date.now(),
      seconds = Math.round((now - this.checkpoint) / 1000);
    this.checkpoint = now;
    if (this.consent === 'yes' && seconds > 0) this.track('session_end', {
      duration_seconds: seconds
    });
  };
  visitor() {
    let value = localStorage.getItem('nt-visitor-id');
    if (!value) {
      value = `${Date.now().toString(36)}-${crypto.getRandomValues(new Uint32Array(2)).join('')}`;
      localStorage.setItem('nt-visitor-id', value);
    }
    return value;
  }
  browser() {
    const ua = navigator.userAgent;
    return ua.includes('Edg/') ? 'Edge' : ua.includes('OPR/') ? 'Opera' : ua.includes('Firefox/') ? 'Firefox' : ua.includes('Chrome/') ? 'Chrome' : ua.includes('Safari/') ? 'Safari' : 'Inna';
  }
  localeCountry() {
    const locale = String(navigator.language || '').replace('_', '-');
    const match = locale.match(/-([A-Za-z]{2})$/);
    return match ? match[1].toUpperCase() : '';
  }
  track(event_type, extra) {
    if (extra === void 0) {
      extra = {};
    }
    portalEvent({
      action: 'analytics',
      consent: true,
      visitor_id: this.visitor(),
      event_type,
      path: location.pathname,
      referrer: document.referrer,
      browser: this.browser(),
      device: matchMedia('(max-width:767px)').matches ? 'mobile' : 'desktop',
      country_code: this.localeCountry(),
      ...extra
    }).catch(() => null);
  }
  decide(value) {
    localStorage.setItem('nt-analytics-consent', value);
    this.consent = value;
    if (value === 'yes') this.track('page_view');
    m.redraw();
  }
  dismiss(id) {
    this.dismissed.push(String(id));
    localStorage.setItem('nt-dismissed-announcements', JSON.stringify(this.dismissed));
  }
  view() {
    const announcements = (this.data.announcements || []).filter(item => !this.dismissed.includes(String(item.id)));
    const path = String(m.route.get() || location.pathname || '/').split('?')[0].replace(/\/$/, '') || '/';
    const isHome = path === '/';
    return m('[', null, !isHome && announcements.length ? m("div", {
      className: "NtGlobalAnnouncements"
    }, announcements.map(item => m("div", {
      className: `NtAnnouncement is-${item.style || 'gold'}`
    }, m("span", null, icon(item.icon || 'fas fa-bullhorn')), m("div", null, m("strong", null, item.title), m("p", null, item.message)), item.link_url ? m(Link, {
      href: item.link_url,
      onclick: () => this.track('social_exit', {
        target_url: item.link_url
      })
    }, item.link_label || 'SPRAWDŹ') : null, item.dismissible ? m("button", {
      type: "button",
      "aria-label": "Zamknij",
      onclick: () => this.dismiss(item.id)
    }, icon('fas fa-times')) : null))) : null, this.consent === null ? m("aside", {
      className: "NtCookieConsent"
    }, m("div", null, icon('fas fa-cookie-bite'), m("span", null, m("strong", null, "Twoja prywatno\u015B\u0107"), m("small", null, "U\u017Cywamy niezb\u0119dnych plik\xF3w technicznych. Analityk\u0119 odwiedzin w\u0142\u0105czymy dopiero po Twojej zgodzie."))), m("div", null, m("button", {
      onclick: () => this.decide('no')
    }, "Tylko niezb\u0119dne"), m("button", {
      className: "Button Button--primary",
      onclick: () => this.decide('yes')
    }, "Akceptuj\u0119 analityk\u0119"))) : null);
  }
}
export class HoverPreview extends Component {
  preview = null;
  timer = null;
  oncreate() {
    document.addEventListener('mouseover', this.over);
    document.addEventListener('mouseout', this.out);
  }
  onremove() {
    document.removeEventListener('mouseover', this.over);
    document.removeEventListener('mouseout', this.out);
  }
  over = event => {
    const row = event.target.closest('.DiscussionListItem');
    if (!row || row.contains(event.relatedTarget)) return;
    const href = row.querySelector('a.DiscussionListItem-main')?.href || '';
    const match = href.match(/\/d\/(\d+)(?:-[^/?#]*)?/);
    if (!match) return;
    this.timer = window.setTimeout(async () => {
      try {
        const discussion = await app.store.find('discussions', match[1], {
          include: 'firstPost,user'
        });
        const post = discussion.firstPost?.();
        const plain = post?.contentPlain?.() || String(post?.contentHtml?.() || '').replace(/<[^>]+>/g, ' ');
        const rect = row.getBoundingClientRect();
        this.preview = {
          title: discussion.title?.(),
          text: plain.slice(0, 420),
          x: Math.min(rect.left + 70, innerWidth - 430),
          y: Math.min(rect.bottom + 8, innerHeight - 220)
        };
        m.redraw();
      } catch {}
    }, 420);
  };
  out = event => {
    const row = event.target.closest('.DiscussionListItem');
    if (!row || row.contains(event.relatedTarget)) return;
    if (this.timer) clearTimeout(this.timer);
    this.preview = null;
    m.redraw();
  };
  view() {
    return this.preview ? m("div", {
      className: "NtHoverPreview",
      style: {
        left: `${Math.max(12, this.preview.x)}px`,
        top: `${Math.max(70, this.preview.y)}px`
      }
    }, m("small", null, "PODGL\u0104D W\u0104TKU"), m("strong", null, this.preview.title), m("p", null, this.preview.text || 'Brak treści do wyświetlenia.')) : null;
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/GlobalPortalShell', { GlobalPortalShell: GlobalPortalShell,HoverPreview: HoverPreview, });